import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Heading, Notice, Separator, List, ListItem } from 'telia-front-react';
import { InternetUseCase } from '../InternetCalculatorInterfaces';
import { useInternetCalculator } from '../InternetCalculatorProvider';
const INTERNET_USE_CASES = [InternetUseCase.SURFING, InternetUseCase.STREAMING, InternetUseCase.VIDEOCALLS, InternetUseCase.GAMING];
const SECURE_NET_USE_CASES = [
    InternetUseCase.SMALL_DEVICES,
    InternetUseCase.SECURE_NET_SURFING,
    InternetUseCase.SECURE_NET_VIDEO_CALLS,
    InternetUseCase.HIGH_SPEED_WORK
];
export const InternetAppropriateUses = (props) => {
    const { offer } = props;
    const { internetCalculatorConfigState, isSecureNet } = useInternetCalculator();
    const { translate } = React.useContext(TranslationsContext);
    const USE_CASES = isSecureNet ? SECURE_NET_USE_CASES : INTERNET_USE_CASES;
    if (!internetCalculatorConfigState.config) {
        return null;
    }
    const getAppropriateActionFromConf = (useCase) => {
        var _a, _b;
        return isSecureNet
            ? +((_a = internetCalculatorConfigState.config.secureNetAppropriateActions) === null || _a === void 0 ? void 0 : _a[useCase])
            : +((_b = internetCalculatorConfigState.config.appropriateActions) === null || _b === void 0 ? void 0 : _b[useCase]);
    };
    const appropriateUseCases = USE_CASES.filter((useCase) => getAppropriateActionFromConf(useCase) <= +offer.downloadSpeed);
    const inAppropriateUseCases = USE_CASES.filter((useCase) => getAppropriateActionFromConf(useCase) > +offer.downloadSpeed);
    const renderUseCases = (useCaseTitleLabel, useCases) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Heading, { level: 2, className: "h4 text-bold" }, translate(useCaseTitleLabel)),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
            React.createElement(List, { type: "icon", iconPosition: "middle", verticalSpacing: "large" }, useCases.map((useCase) => (React.createElement(ListItem, { key: useCase, icon: translate(`internetCalculator.details.useCaseIcon.${useCase}`), iconClassName: "icon--sm hidden-sm hidden-xs" }, translate(`internetCalculator.details.useCase.${useCase}`)))))));
    };
    return (React.createElement(React.Fragment, null,
        !!appropriateUseCases.length && renderUseCases('internetCalculator.details.appropriateUseCases', appropriateUseCases),
        !!inAppropriateUseCases.length && (React.createElement(React.Fragment, null,
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
            renderUseCases('internetCalculator.details.inAppropriateUseCases', inAppropriateUseCases))),
        React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
        !isSecureNet && React.createElement(Notice, null, translate('internetCalculator.details.appropriateUseCases.notice'))));
};
